import { createAsyncThunk } from '@reduxjs/toolkit';
import { createNewOrder } from './orderServices';
import { CreateOrderRequest, CreateOrderResponse } from './orderModels';

/**
 * Async thunk for creating an order
 */
export const createOrder = createAsyncThunk<
  CreateOrderResponse,
  CreateOrderRequest,
  { rejectValue: string }
>(
  'orders/createOrder',
  async (orderData: CreateOrderRequest, { rejectWithValue }) => {
    try {
      const data = await createNewOrder(orderData);
      return data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to create order'
      );
    }
  }
);

